export default __webpack_public_path__ + "static/media/video2.46342978.mp4";